import * as React from 'react'
import Scrollchor from 'react-scrollchor'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/menu.css'
import styles from './styles.module.scss'
import { textToClassName } from 'lib/textToClassName'
import { CategoryDefinitions } from 'types/categoryDefinitions'
import clsx from 'clsx'

interface Props {
  activeCategory: string
  categories: CategoryDefinitions
}

function trackClicksOnCategoryMenu(categoryClicked: string) {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: 'Interactions',
    event_action: 'click',
    event_label: `categoryMenu:${categoryClicked}`
  })
}

export function CategoryMenu({ activeCategory, categories }: Props) {
  const categoryKeys = Object.keys(categories)

  return (
    <div className={clsx('category-menu', styles.categoryMenu)}>
      <div className='ui attached inverted menu'>
        <div className='ui container'>
          {categoryKeys.map(category => {
            const shortVersion = categories[category].shortName || category
            const cleanedCategory = textToClassName(shortVersion)

            return (
              <Scrollchor
                afterAnimate={() => {
                  trackClicksOnCategoryMenu(cleanedCategory)
                }}
                key={`${cleanedCategory}`}
                to={`#${cleanedCategory}`}
                animate={{ offset: -47 }}
                className={clsx(
                  'item',
                  styles.item,
                  activeCategory === cleanedCategory && 'active'
                )}
                style={{
                  backgroundColor:
                    activeCategory === cleanedCategory
                      ? categories[category].colors.gradientEnd
                      : 'transparent'
                }}
              >
                {shortVersion}
              </Scrollchor>
            )
          })}
        </div>
      </div>
    </div>
  )
}
